/*
 * @Author: kennthKun c_kunx@163.com
 * @Date: 2022-10-31 14:04:02
 * @LastEditors: kennthKun c_kunx@163.com
 * @LastEditTime: 2022-11-04 10:43:33
 * @FilePath: /kx_component/src/components/input/default.ts
 */
export default {
  valueType: "text",
  FormItemProps: {
    label: '文本',
    style: {},
    rules: [
      {
        pattern: /^\S.*\S$|(^\S{0,1}\S$)/,
        message: '前后不可输入空格',
      },
    ],
  },
  ControlProps: {
    prefix: "", // 带有前缀图标的 input
    suffix: "", // 带有后缀图标的 input
    disabled: false,
    maxLength: null,
    placeholder: "请输入",
    allowClear: true,
    style: {}
  },

}
